window.smoothScroll = function () {
  $('a[href^="#"]').on('click', function () {
    var href = $(this).attr('href');
    if (href != '#') {
      $('html, body')
        .stop()
        .animate(
          { scrollTop: $(href == '#top' ? 'html' : href).offset().top },
          500
        );
      return false;
    }
  });
};

$(function () {
  smoothScroll();
});

$(function () {
  $('.summary__drop--ttl').on('click', function () {
    if (!$('.summary__drop--ttl').hasClass('down')) {
      $('.summary__drop--ans:not(:animated)', this).slideDown();
      $('.summary__drop--ttl').addClass('down');
    }
    // else {
    //   $('.summary__drop--ans', this).slideUp();
    //   $('.summary__drop--ttl').removeClass('down');
    // }
  });
  $('.close').on('click', function () {
    $('.summary__drop--ans', '.summary__drop--ttl').slideUp();
    $('.summary__drop--ttl').removeClass('down');
  });
  $('.campaign__detailInfo--btn').on('click', function () {
    $('.summary__drop--ans', '.summary__drop--ttl').slideUp();
    $('.summary__drop--ttl').removeClass('down');
  });
});
